module.exports = __webpack_public_path__ + "img/2.7150c15f.jpg";